// src/directives/ibanFormat.js

function formatIban(value) {
  if (!value) return '';
  // Nur Buchstaben/Zahlen, Rest raus
  var cleaned = value.replace(/[^a-zA-Z0-9]/g, '').toUpperCase();
  // In 4er-Gruppen splitten
  var groups = cleaned.match(/.{1,4}/g);
  return groups ? groups.join(' ') : cleaned;
}

export const ibanFormat = {
  mounted(el) {
    const input =
      el instanceof HTMLInputElement ? el : el.querySelector('input');
    if (!input) return;

    const onInput = (event) => {
      const target = event.target;
      const raw = target.value;

      // aktuelle Cursor-Position
      const oldPos = target.selectionStart || raw.length;
      const beforeCursor = raw.slice(0, oldPos);

      const formatted = formatIban(raw);
      const formattedBeforeCursor = formatIban(beforeCursor);

      target.value = formatted;

      // Cursor halbwegs sinnvoll wiederherstellen
      const newPos = formattedBeforeCursor.length;
      requestAnimationFrame(() => {
        target.setSelectionRange(newPos, newPos);
      });
    };

    // Handler merken, damit wir ihn beim Unmount wieder entfernen können
    input._ibanOnInput = onInput;

    input.addEventListener('input', onInput);

    // initial formatieren
    input.value = formatIban(input.value);
  },

  beforeUnmount(el) {
    const input =
      el instanceof HTMLInputElement ? el : el.querySelector('input');
    if (!input) return;

    const handler = input._ibanOnInput;
    if (handler) {
      input.removeEventListener('input', handler);
      delete input._ibanOnInput;
    }
  },
};
